export const MatchDocumentType = Object.freeze({
  offer: 'offer',
  application: 'application',
});

export const MatchDocumentTooltip = Object.freeze({
  offer: 'You got an <b>Instant Offer!</b> This lender is integrated directly into Capitalise.',
  application:
    'We sent an <b>Instant Application!</b> This lender is integrated directly into Capitalise.',
});
